/**
 * kod-ingredients-layout — reserve la place du menu accordeon (desktop) sous la
 * composition d'ingredients.
 *
 * Sur desktop l'accordeon est positionne en absolute dans le canvas (qui a un
 * aspect-ratio fixe), il ne pousse donc pas la hauteur de la section. Sans
 * reserve, son contenu deborde et chevauche les sections suivantes (highlight,
 * titre). On mesure le debordement reel de l'accordeon sous le canvas et on
 * l'expose via `--kod-ing-accordion-reserve`, que le CSS ajoute au
 * padding-block-end de la section.
 */
(function () {
  const SELECTOR = '.kod-ingredients';
  const DESKTOP_MQ = '(min-width: 750px)';

  function setup(section) {
    const canvas = section.querySelector('.kod-ingredients__canvas');
    const accordion = section.querySelector('.kod-notes-accordion--desktop');
    if (!canvas || !accordion) return;

    const mq = window.matchMedia(DESKTOP_MQ);

    const measure = () => {
      if (!mq.matches) {
        section.style.removeProperty('--kod-ing-accordion-reserve');
        return;
      }
      const overflow =
        accordion.getBoundingClientRect().bottom - canvas.getBoundingClientRect().bottom;
      section.style.setProperty(
        '--kod-ing-accordion-reserve',
        (overflow > 0 ? Math.ceil(overflow) : 0) + 'px'
      );
    };

    const schedule = () => window.requestAnimationFrame(measure);

    if ('ResizeObserver' in window) {
      const ro = new ResizeObserver(schedule);
      ro.observe(accordion);
      ro.observe(canvas);
    }

    // L'ouverture/fermeture d'un item change la hauteur de l'accordeon.
    accordion.addEventListener('toggle', schedule, true);
    window.addEventListener('resize', schedule, { passive: true });
    if (mq.addEventListener) {
      mq.addEventListener('change', schedule);
    }

    schedule();
  }

  function init() {
    document.querySelectorAll(SELECTOR).forEach(setup);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
